<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditHoliday
			v-if="holiday_item !== null"
			:editEventItem="holiday_item"
			:isEdit="holiday_item !== null"
			:color="'#FFB946'"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditHoliday from "@/views/events/new_holiday.vue";


export default {
	name: 'EditleaveDialog',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: true,
			error_msg: '',

			holiday_id: 0,
			iteration: 1,
			holiday_item: null
		}
	},
	components: {
		EditHoliday
	},
	created() {
		this.holiday_id = Number(this.$route.params.evid);
		this.iteration = Number(this.$route.query.iteration);

		this.getHoliday(this.holiday_id, this.iteration);
	},
	methods: {
		async getHoliday(id, iteration) {
			this.loading = true;

			const url = `/api/events/${id}?iteration=${iteration}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						this.holiday_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>


